module.exports = __webpack_public_path__ + "img/video-player/volume-1-f82c0f5089c00f40d4d7512e1437d128.svg";